import { Injectable, Input } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MiddleServiceService {

  @Input() redirectTo = '';
  constructor() { }

  takeRedirectToDetail(): boolean {
    if (this.redirectTo !== undefined && this.redirectTo !== null && this.redirectTo !== '') {
      return true;
    }
    return false;
  }

}
